/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestResultDto } from '../../models/contents-request-result-dto';

export interface ContentsRequestResultControllerFindByContentsRequestId$Params {
  contentsRequestId: string;
  clientWorkspaceId?: string;
}

export function contentsRequestResultControllerFindByContentsRequestId(http: HttpClient, rootUrl: string, params: ContentsRequestResultControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestResultDto>>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestResultControllerFindByContentsRequestId.PATH, 'get');
  if (params) {
    rb.path('contentsRequestId', params.contentsRequestId, {});
    rb.query('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContentsRequestResultDto>>;
    })
  );
}

contentsRequestResultControllerFindByContentsRequestId.PATH = '/api/contents-request-result/{contentsRequestId}/contentsRequest';
